import { config } from 'process';

import { useParams } from 'react-router';

import { AxiosResponse } from 'axios';
import { FormikHelpers } from 'formik';
import { enqueueSnackbar } from 'notistack';

import { usePermissionsContext } from 'context/PermissionsContext';
import { useShowError } from 'hooks/useShowError';
import { useFormMutation } from 'mutations/useFormMutation';
import { GrupoExibicaoProps } from 'pages/cadastro/loja/types';
import { useGrupoExibicaoContext } from 'pages/cadastro/secoes/contexts/GrupoExibicaoContext';

let url = '/gestao/configuracaopropriedadegrupoexibicao/';

export function useMutateGrupoExibicao() {
    const { mutate, isLoading } = useFormMutation<AxiosResponse<GrupoExibicaoProps[]>>();
    const { showError } = useShowError();
    const { id } = useParams();
    const { hasPermission } = usePermissionsContext();
    const { setOpenModalGrupoExibicao } = useGrupoExibicaoContext();

    const onSubmitForm = (formData: GrupoExibicaoProps, formik: FormikHelpers<GrupoExibicaoProps>) => {
        url = `/gestao/configuracaopropriedadegrupoexibicao/ordenado?fgReordena=${Boolean(formData?.fgReordena)}`;

        if (id) {
            url = `/gestao/configuracaopropriedadegrupoexibicao/${id}/ordenado?fgReordena=${Boolean(formData?.fgReordena)}`;
        }

        let updatedFormData = null;

        if (formData.configuracaoPropriedadeGrupoExibicaoGrupoUsuario) {
            updatedFormData = formData.configuracaoPropriedadeGrupoExibicaoGrupoUsuario.map((item) => ({
                grupoUsuario: { dsGrupoUsuario: item.dsGrupoUsuario, idGrupoUsuario: item.idGrupoUsuario },
            }));
        }

        const fullFormData = updatedFormData ? { ...formData, configuracaoPropriedadeGrupoExibicaoGrupoUsuario: updatedFormData } : formData;

        mutate(
            {
                url,
                formData: fullFormData,
                formik,
                method: id ? 'PUT' : 'POST',
                preventSnack: true,
                preventRedirect: !!hasPermission(['LOJA_ALTERAR']),
            },
            {
                onSuccess: () => {
                    enqueueSnackbar('Seção salva com sucesso', { variant: 'success' });
                },
                onError: (error: any) => {
                    showError(error, 'Erro ao salvar seção');
                    setOpenModalGrupoExibicao(true);
                },
            },
        );
    };

    return { onSubmitForm, isLoading };
}
